import { type MarketplaceState } from "../lib/verified-copy";
import { useMarketplaceState } from "./useMarketplaceState";

/**
 * SILL-504 — THE single consumer marketplace launch gate.
 *
 * Every consumer marketplace surface (`/marketplace/browse`, `/offers`,
 * `/offers/:id`, `/market/agents/:id`, `/market/agents/:id/offers/:ref`,
 * and the sidebar Marketplace items) gates on this hook, which rides
 * `marketplace_go_live_enabled` via `useMarketplaceState`. Launch day is
 * one PostHog toggle; there is no second consumer marketplace flag.
 *
 * FAIL-CLOSED in production: `useMarketplaceState` resolves "post" only on
 * an explicit loaded `true` — a missing flag, an unloaded/blocked SDK
 * (`undefined`), or an explicit `false` all resolve "pre" and gate the
 * surfaces. The M5-era fail-open shape (`flag !== false`) is retired; it
 * predated real money flows on these routes.
 *
 * DEV short-circuit: local dev, `/preview/*` fixtures, and ui-verify runs
 * have no PostHog key, so `import.meta.env.DEV` builds render the surfaces
 * unconditionally (same shape the browse gate used).
 *
 * Staging QA: riding `useMarketplaceState` inherits the
 * `?flags=marketplace_go_live_enabled` sessionStorage force-on override,
 * so a production build can be QA'd before the real flag flips.
 */
export function resolveConsumerMarketplaceEnabled(
  state: MarketplaceState,
  dev: boolean,
): boolean {
  return dev || state === "post";
}

export function useConsumerMarketplaceEnabled(): boolean {
  return resolveConsumerMarketplaceEnabled(
    useMarketplaceState(),
    import.meta.env.DEV,
  );
}
